"use strict";
// Class definition
import Swiper from "swiper";
import {Autoplay, Navigation, Pagination} from "swiper/modules"
import Swal from 'sweetalert2/dist/sweetalert2'
import ma5menu from "./ma5-menu";
import {Modal} from 'bootstrap';
import SVGInject from '@iconfu/svg-inject';
// import WOW from "wow.js/dist/wow";
import Cookies from 'js-cookie'
import {detectIncognito} from "detectincognitojs";
import AutoNumeric from "autonumeric";

var MainScripts = function () {
    jQuery.fn.exists = function () {
        return this !== null && this !== undefined;
    }

    var swiperUse = function () {
        Swiper.use([Navigation, Pagination, Autoplay]);
    }

    var homeSwipers = function () {

        var interleaveOffset = 0.5;

        let videos = document.querySelectorAll('.home-slider .swiper-slide video');
        videos.forEach(function ($el) {
            let ths = $el;
            let load = setInterval(function () {
                if (ths.readyState >= 1) {
                    let duration = (ths.duration * 1000) - 1000
                    if (duration > 0) {
                        ths.closest(".swiper-slide").setAttribute('data-swiper-autoplay', duration);

                        setTimeout(function () {
                            let index = Object.values(document.querySelectorAll('.home-slider .swiper-slide')).indexOf(ths.parentElement.parentElement);
                            $(".pagination-navigation .pagination .swiper-pagination-bullet").eq(index)
                                .find('.active-line').css("animation-duration", (duration + 1000) + 'ms');
                        }, 500)
                    }
                    clearInterval(load);
                }
            }, 100)
        });

        setTimeout(function () {
            const home_slider = new Swiper('.home-slider', {
                loop: false,
                speed: 1000,
                grabCursor: true,
                watchSlidesProgress: true,
                mousewheelControl: true,
                keyboardControl: true,
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false
                },
                on: {
                    init: function (swiper) {

                        // let activeElemWrapper = swiper.slides[swiper.activeIndex].querySelector('picture');
                        // if (!activeElemWrapper.querySelector('img')) {
                        //     let activeElemImg = document.createElement('img');
                        //     activeElemImg.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
                        //     activeElemImg.alt = activeElemWrapper.getAttribute('alt-text');
                        //     activeElemWrapper.appendChild(activeElemImg);
                        // }

                        var currentVideo = $("[data-swiper-slide-index=" + this.activeIndex + "]").find("video");
                        currentVideo.trigger('play');
                    },
                    slideChange: function (swiper) {
                        videos.forEach(function (ths) {
                            ths.currentTime = 0;
                        });
                        var prevVideo = $("[data-swiper-slide-index=" + this.previousIndex + "]").find("video");
                        var currentVideo = $("[data-swiper-slide-index=" + this.realIndex + "]").find("video");
                        prevVideo.trigger('stop');
                        currentVideo.trigger('play');


                        // let activeElemWrapper = swiper.slides[swiper.activeIndex].querySelector('picture');
                        // if (!activeElemWrapper.querySelector('img')) {
                        //     let activeElemImg = document.createElement('img');
                        //     activeElemImg.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
                        //     activeElemImg.alt = activeElemWrapper.getAttribute('alt-text');
                        //     activeElemWrapper.appendChild(activeElemImg);
                        // }
                    }
                }
            });
        }, 500);


        new Swiper(".guide-to-turkey .swiper", {
            spaceBetween: 15,
            slidesPerView: 6,
            slidesPerGroup: 6,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            pagination: {
                el: '.guide-to-turkey .swiper-pagination',
                clickable: true
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    slidesPerGroup: 1
                },
                576: {
                    slidesPerView: 2,
                    slidesPerGroup: 2
                },
                768: {
                    slidesPerView: 3,
                    slidesPerGroup: 3
                },
                1024: {
                    slidesPerView: 4,
                    slidesPerGroup: 4
                },
                1300: {
                    slidesPerView: 5,
                    slidesPerGroup: 5,
                },
                1520: {
                    slidesPerView: 6,
                    slidesPerGroup: 6,
                },
                1600: {
                    spaceBetween: 33
                }
            }
        });

        new Swiper(".home-blogs .swiper", {
            spaceBetween: 30,
            slidesPerView: 3,
            slidesPerGroup: 3,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            pagination: {
                el: '.home-blogs .l-side .swiper-pagination',
                clickable: true
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                },
                480: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                768: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                992: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                1300: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                1600: {
                    spaceBetween: 60,
                    slidesPerGroup: 3,
                }
            }
        });
    }

    const scrollToAlert = () => {
        setTimeout(function () {
            let alert = $('.alert');
            if (alert.exists()) {
                let offset = alert.offset();
                let top = offset.top;
                window.scrollTo({
                    top: top,
                    behavior: 'smooth'
                });
            }
        }, 300)
    }

    var otherSwipers = function () {

        var propertyItems = document.querySelectorAll('.property-item');

        propertyItems.forEach(function (propertyItem) {
            var swiper = new Swiper(propertyItem.querySelector('.image .swiper'), {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                navigation: {
                    prevEl: propertyItem.querySelector('.image .navigation .prev'),
                    nextEl: propertyItem.querySelector('.image .navigation .next')
                },
                on: {
                    init: function (swiper) {
                        let activeElemImg = swiper.slides[swiper.activeIndex].querySelector('img');
                        if (activeElemImg.getAttribute('slide-src')) {
                            activeElemImg.src = activeElemImg.getAttribute('slide-src');
                            activeElemImg.removeAttribute('slide-src');
                        }
                    },
                    slideChange: function (swiper) {
                        let activeElemImg = swiper.slides[swiper.activeIndex].querySelector('img');
                        if (activeElemImg.getAttribute('slide-src')) {
                            activeElemImg.src = activeElemImg.getAttribute('slide-src');
                            activeElemImg.removeAttribute('slide-src');
                        }
                    }
                }
            });
        });
    }


    var formPOST = function () {
        let forms = document.querySelectorAll('form[method="post"]:not(.no-ajax)');
        if (forms.length > 0) {
            forms.forEach(function (el) {
                el.addEventListener('submit', function (e) {
                    e.preventDefault();
                    let form = this;
                    form.querySelector('button[type="submit"]').setAttribute('disabled', 'disabled');
                    Swal.fire({
                        title: window.lang.formSendingText,
                        icon: 'info',
                    }).then(() => {
                    });
                    form.submit();
                })
            });
        }
    }


    var getKvKK = function () {
        if (document.querySelectorAll('.kvkk')) {
            document.querySelectorAll('.kvkk').forEach(function (el) {
                el.addEventListener('click', function () {
                    fetch(window.siteurl + 'kvkk', {
                        method: 'POST',
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Data-Type': 'application/json'
                        }
                    }).then((response) => response.json())
                        .then((data) => {
                            const myModal = CreateModal(data);
                            myModal.show();
                        }).catch((error) => {
                        console.error('Error:', error);
                        Swal.fire({
                            icon: 'error',
                            title: window.lang.formError
                        }).then(() => {
                        })
                    });
                });
            })
        }
    }


    function CreateModal(dt) {
        let id = '#kvkk-' + dt.id;
        let element = document.getElementById(id);
        if (typeof (element) != 'undefined' && element != null) {
            $(id).find("#ModalLabel").text(dt.title);
            $(id).find("#ModalContent").html(dt.description);
        } else {
            $('body').append('<div class="modal fade" id="' + id + '" tabindex="-1">\n' +
                '  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl kvkk-modal">\n' +
                '    <div class="modal-content">\n' +
                '      <div class="modal-header">\n' +
                '        <h5 class="modal-title" id="ModalLabel">' + dt.title + '</h5>\n' +
                '        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Kapat"></button>\n' +
                '      </div>\n' +
                '      <div class="modal-body" id="ModalContent"><div class="page-content">\n' + dt.description +
                '      </div>\n' +
                '      </div>\n' +
                '      <div class="modal-footer">\n' +
                '        <button type="button" class="btn btn-secondary text-white" data-bs-dismiss="modal">' + window.lang.closeButton + '</button>\n' +
                '      </div>\n' +
                '    </div>\n' +
                '  </div>\n' +
                '</div>');
            element = document.getElementById(id);
        }
        return new Modal(element, {});
    }

    var contacts = function () {

        $('.whatsapp_bubble').on('click', function () {
            if ($('.whatsapp_pp').hasClass('active')) {
                $('.whatsapp_pp').removeClass('active')
            } else {
                $('.whatsapp_pp').addClass('active')
            }
        });

        setTimeout(function () {
            $('.whatsapp_bubble').trigger('click');
        }, 30000);


        $('.whatsapp_pp .close_pp').on('click', function () {
            $('.whatsapp_pp').removeClass('active')
        });
    }

    function isScrolledIntoView(element) {
        return new Promise(resolve => {
            let observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.intersectionRatio > 0) {
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                });
            });

            observer.observe(element);
        });
    }

    var observer = function () {

        const observer = new IntersectionObserver(entries => {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    let lazyImage = entry.target;
                    lazyImage.classList.add('loaded');
                    lazyImage.src = lazyImage.dataset.src;
                    lazyImage.classList.remove("lazy");
                    observer.unobserve(lazyImage);
                }
            });
        }, {
            rootMargin: "0px"
        });

        $(function () {
            let srcItems = document.querySelectorAll('[data-src]');
            srcItems.forEach(box => {
                observer.observe(box);
            });
        });

        const lazyBackgroundImages = document.querySelectorAll('.lazy-bg');


        const imageObserver = new IntersectionObserver((entries, imageObserver) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    showImageBackground(entry.target);
                    imageObserver.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0,
            rootMargin: "0px 0px 50px 0px"
        });

        lazyBackgroundImages.forEach(image => {
            imageObserver.observe(image);
        });

        function showImageBackground(node) {
            node.classList.remove('lazy-bg');
        }
    }

    function countFavorites() {
        let favorites = Cookies.get('favorites');
        if (favorites) {
            favorites = JSON.parse(Cookies.get('favorites'));
            document.querySelector('.favorites .count').innerText = Object.keys(favorites).length;
        }
    }

    var onload = function () {

        if (screen.width <= 768 && !Cookies.get('popup')) {
            if ($('#callingPopupModal').length > 0) {
                let PopupModal = new Modal(document.getElementById('callingPopupModal'))
                setTimeout(function () {
                    PopupModal.show()
                }, 10000);

                var pp = document.getElementById('callingPopupModal')
                pp.addEventListener('hidden.bs.modal', function () {
                    if ($('#neverShowAgain').is(':checked')) {
                        var inFiveMinutes = new Date(new Date().getTime() + 5 * 60 * 1000)
                        Cookies.set('popup', 'true', {expires: inFiveMinutes});
                    }
                })
            }
        }

        SVGInject(document.querySelectorAll('img.svg-inject'));

        $('.mobile-menu-btn').on('click', function () {
            if (!$(this).hasClass('active')) {
                $(this).addClass('active');
                $(this).find('svg').html('<use xlink:href="/assets/images/sprite.svg#times"></use>')
                $(this).parents('aside').addClass('sidebar-active');
            } else {
                $(this).removeClass('active');
                $(this).find('svg').html('<use xlink:href="/assets/images/sprite.svg#bars-light"></use>')
                $(this).parents('aside').removeClass('sidebar-active');
            }
        });

        if (window.location.hash === '#FormModal') {
            new Modal(document.getElementById('FormModal')).show();
        }


        ma5menu({
            menu: '.site-menu',
            activeClass: 'active',
            footer: '#ma5menu-tools',
            position: 'left',
            closeOnBodyClick: true,
        });

        document.querySelectorAll('.add-to-favorites').forEach(function (el) {
            el.addEventListener('click', function () {
                let propertyId = this.dataset.propertyId;
                if (el.classList.contains('added')) {
                    el.classList.remove('added');
                    if (el.classList.contains('favorites-page')) {
                        el.parentElement.parentElement.parentElement.remove();
                        if (document.querySelectorAll('.add-to-favorites').length < 1)
                            setTimeout(function () {
                                window.location.reload();
                            }, 1000);
                    }
                } else {
                    detectIncognito().then((result) => {
                        if (result.isPrivate) {
                            Swal.fire({
                                icon: 'warning',
                                title: window.lang.warning,
                                text: window.lang.incognito_mode,
                            });
                        }
                    });
                    el.classList.add('added');
                }

                if (Cookies.get('favorites')) {
                    let favorites = JSON.parse(Cookies.get('favorites'));
                    if (favorites.includes(propertyId)) {
                        let index = favorites.indexOf(propertyId);
                        if (index > -1) {
                            favorites.splice(index, 1);
                            Swal.fire({
                                position: 'top-end',
                                icon: 'success',
                                title: window.lang.removedFromFavorites,
                                showConfirmButton: false,
                                timer: 1000
                            })
                        }
                    } else {
                        favorites.push(propertyId);
                        Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: window.lang.addedToFavorites,
                            showConfirmButton: false,
                            timer: 1000
                        });
                    }
                    Cookies.set('favorites', JSON.stringify(favorites));
                } else {
                    Cookies.set('favorites', JSON.stringify([propertyId]));
                    Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: window.lang.addedToFavorites,
                        showConfirmButton: false,
                        timer: 1000
                    });
                }
                countFavorites();
            });
        })

        let currencySymbol = "$";
        if (Cookies.get('currency')) {
            switch (Cookies.get('currency')) {
                case 'EUR':
                    currencySymbol = '€';
                    break;
                case 'GBP':
                    currencySymbol = '£';
                    break;
                case 'TRY':
                    currencySymbol = '₺';
                    break;
            }
        }

        let currency_options = {
            unformatOnSubmit: !0,
            decimalPlacesRawValue: null,
            digitGroupSeparator: ".",
            decimalCharacter: ",",
            decimalCharacterAlternative: ".",
            currencySymbol: currencySymbol,
            maximumValue: "999999999999999.99",
            minimumValue: "0",
            decimalPlaces: "3",
            modifyValueOnWheel: false,
            watchExternalChanges: true,
            allowPaste: true
        };
        $(document).find('.autonumeric').each(function () {
            $(this).data("autonumeric") || $(this).data("autonumeric", new AutoNumeric(this, currency_options))
        });
    }

    let StickyHeader = () => {
        $(window).scroll(function () {
            let header = $('header');
            let headerHeight = header.outerHeight();
            let stickyOffset = 110;
            if (header.hasClass('sticky-menu') && headerHeight === 67) {
                stickyOffset = headerHeight;
            }

            if ($(window).scrollTop() >= stickyOffset) {
                if (!header.hasClass('sticky-menu')) {
                    $('body').css('padding-top', headerHeight + 'px');
                }
                header.addClass('sticky-menu');
                setTimeout(function () {
                    header.css({
                        'transition': 'transform 0.3s ease-in-out',
                        'transform': 'translateY(0)'
                    });
                }, 300);


            } else {
                header.removeClass('sticky-menu');
                $('body').css('padding-top', 0);
                header.css({
                    'transition': '',
                    'transform': ''
                });
            }
        });
    }

    var countUp = function () {
        if (document.querySelectorAll('.count').length > 0) {
            var firstScrolled = false;
            if (isScrolledIntoView(document.querySelector('.count'))) {
                document.querySelectorAll('.count').forEach(function (el) {
                    let count = new CountUp(el, el.getAttribute('data-end'));
                    if (!count.error) {
                        count.start();
                    } else {
                        console.error(count.error);
                    }
                });
                firstScrolled = true;
            }
        }
    }

    function getDocumentOffsetPosition(el) {
        let top = 0, left = 0;
        while (el !== null) {
            top += el.offsetTop;
            left += el.offsetLeft;
            el = el.offsetParent;
        }
        return {top, left, el};
    }

    function isVisibleInViewport(elem) {
        var y = getDocumentOffsetPosition(elem).top;
        var height = elem.offsetHeight;

        while (elem = elem.offsetParent)
            y += elem.offsetTop;
        var isVisible = (y > window.pageYOffset);
        return isVisible;

    }

    return {
        init: function () {

            observer();
            swiperUse();
            homeSwipers();
            otherSwipers();
            getKvKK();
            scrollToAlert();
            // countUp();
            formPOST();
            contacts();
            onload();
        },
    };
}();

// On document ready
jQuery(document).ready(function () {
    MainScripts.init();
});